import { AksClusterLinksFormatter } from './AksClusterLinksFormatter.esm.js';
import { EksClusterLinksFormatter } from './EksClusterLinksFormatter.esm.js';
import { GkeClusterLinksFormatter } from './GkeClusterLinksFormatter.esm.js';
import { StandardClusterLinksFormatter } from './StandardClusterLinksFormatter.esm.js';
import { OpenshiftClusterLinksFormatter } from './OpenshiftClusterLinksFormatter.esm.js';
import { RancherClusterLinksFormatter } from './RancherClusterLinksFormatter.esm.js';

const DEFAULT_FORMATTER_NAME = "standard";
function getDefaultFormatters(deps) {
  return {
    standard: new StandardClusterLinksFormatter(),
    aks: new AksClusterLinksFormatter(),
    eks: new EksClusterLinksFormatter(),
    gke: new GkeClusterLinksFormatter(deps.googleAuthApi),
    openshift: new OpenshiftClusterLinksFormatter(),
    rancher: new RancherClusterLinksFormatter()
  };
}

export { AksClusterLinksFormatter, DEFAULT_FORMATTER_NAME, EksClusterLinksFormatter, GkeClusterLinksFormatter, OpenshiftClusterLinksFormatter, RancherClusterLinksFormatter, StandardClusterLinksFormatter, getDefaultFormatters };
//# sourceMappingURL=index.esm.js.map
